export default __webpack_public_path__ + "static/media/proj2.46dd806a.png";